import { render, staticRenderFns } from "./AttachmentFileViewer.vue?vue&type=template&id=5846ce80&scoped=true"
import script from "./AttachmentFileViewer.vue?vue&type=script&lang=js"
export * from "./AttachmentFileViewer.vue?vue&type=script&lang=js"
import style0 from "./AttachmentFileViewer.vue?vue&type=style&index=0&id=5846ce80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846ce80",
  null
  
)

export default component.exports